import {
  SET_USER_ALL, MODIFY_USER_INFO, SET_USER_STANDINS, MODIFY_USER_CONFIG, UPDATE_RESIZER_HELP, UPDATE_RESIZER_WF,
  MODIFY_SETTINGS_INFO, SET_USER_PREFERENCE, SET_STANDIN_RESALTED,
} from '../types';
import store from '../store';

export const setUserAll = (user) => ({
  type: SET_USER_ALL,
  payload: user,
});

export const setUserStandIns = (standIns) => ({
  type: SET_USER_STANDINS,
  payload: standIns,
});

export const setUserInfo = (user) => ({
  type: MODIFY_USER_INFO,
  payload: user,
});

export const setUserConfig = (user, save = true) => ({
  type: MODIFY_USER_CONFIG,
  payload: user,
  save,
});

export const setResizerWF = (value, save) => ({
  type: UPDATE_RESIZER_WF,
  payload: value,
  save,
  filtersConfig: store.getState().overviewFiltersReducer,
});

export const setResizerHelp = (value, save) => ({
  type: UPDATE_RESIZER_HELP,
  payload: value,
  save,
  filtersConfig: store.getState().overviewFiltersReducer,
});

export const setSettingsInfo = (settings) => ({
  type: MODIFY_SETTINGS_INFO,
  payload: settings,
});

export const setUserPreference = (settings) => ({
  type: SET_USER_PREFERENCE,
  payload: settings,
});

export const setStandInFirstTimeResalted = (setting) => ({
  type: SET_STANDIN_RESALTED,
  payload: setting,
});
